import { transformValues } from 'warbler';

const pixelsToRems = (value, base = 16) => {
  const convert = str =>
    str.includes('px') ? `${Number(str.split('px')[0]) / base}rem` : str;

  if (typeof value !== 'string') {
    return value;
  } else if (!value.includes('px')) {
    return value;
  } else if (value.includes(' ')) {
    return value.split(' ').map(convert).join(' ');
  } else {
    return convert(value);
  }
};

export const updateTheme = theme => ({
  ...theme,
  fontSizes: transformValues(theme.fontSizes, pixelsToRems),
});
